import './vendor';
import './router';
import './components/social';
import './components/video.js';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';


ieFix();
vhFix();
actualYear();
scrollToAnchor.init();
lazyLoading.init();
